var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"loading":_vm.loading}}),(!_vm.error)?_c('span',[_vm._v("Maneno SSO")]):_vm._e(),(_vm.error)?_c('SsoError',{attrs:{"message":_vm.error}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }